import React from "react";

export default function CrossIcon(props) {
  const [hover, setHover] = React.useState(false);
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {hover && <rect width="16" height="16" rx="8" fill={props.fill} fill-opacity="0.32" />}
      <path d="M10 6L6 10" stroke={props.fill} stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M6 6L10 10" stroke={props.fill} stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
